
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's36d03270bec1a22a': `Points forts du voyage`,
's885970c4ee8d21cc': `Fermer`,
'se175c12adadf0b44': `Zurueck zum Kalender`,
's3422841eb3a56b42': `Zurueck`,
    };
  